import "../../../../assets/css/filtro-generico.min.css";
import DropDownListMultipleCustomizedFilter from "../../kit-mdtw/DropDownListMultipleCustomizedFilter";

interface IDropDownMultipleFiltro {
  layer: string;
  list: any;
  onValueChange?: Function;
  onPropertyChange?: string | any;
  onPermaValues?: any;
  localStorageFilter: any; 
}

export default (props: IDropDownMultipleFiltro) => {
  const { layer, list, onValueChange, onPermaValues, onPropertyChange } = props;

  return (
    <>
      <div className="section-filter">
        <span className="title">{layer}</span>
        <div className="content-input-filter">
          <DropDownListMultipleCustomizedFilter
            list={list}
            onValueChange={onValueChange}
            onPropertyChange={onPermaValues}
            onPermaValues={onPropertyChange}
          />
        </div>
      </div>
    </>
  );
};
